<script>
import ModalLoading from "@/components/other/ModalLoading.vue";
import ModalQrCode from "@/components/profile/modal/ModalQrCode";
import { useDialog } from "@/services/dialogService";
import { refreshFont } from "@/services/font";

const TIER_BADGE_IMG = require("@/assets/images/lacoste/Artboard1 2.png");
const BIRTHDAY_ICON = require("@/assets/images/lacoste/Anniversaire.png");
const PHONE_ICON = require("@/assets/images/lacoste/Frame.png");

export default {
  name: "LacosteHome",
  components: { ModalLoading, ModalQrCode },
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  data() {
    return {
      langs: this.$cookies.isKey("lang") ? this.$cookies.get("lang") : {},
      languageList: this.$store.state.languageList,
      displayMemberLevel:
        this.$store.state.theme.line_display_member_level == "1",
      displaySettingBtn:
        !this.$config.line_display_setting_button ||
        this.$config.line_display_setting_button == "1",
      displayEditProfile: this.$config.display_edit_profile == 1,
      displayLogoutButton:
        this.$store.state.theme.line_display_logout_button == "1"
    };
  },
  computed: {
    profile() {
      return this.$store.state.shortProfile || {};
    },
    lineProfile() {
      return this.$cookies.get("user_profile_token") || {};
    },
    avatar() {
      return (
        this.profile.image_url ||
        this.lineProfile.pictureUrl ||
        this.handleImageSrc
      );
    },
    fullName() {
      const first = this.profile.first_name_th || "";
      const middle = this.profile.middle_name_th || "";
      const last = this.profile.last_name_th || "";
      const composed = [first, middle, last].filter(Boolean).join(" ").trim();
      return composed || this.lineProfile.displayName || "-";
    },
    shortName() {
      const first = this.profile.first_name_th || "";
      const last = this.profile.last_name_th || "";
      const initial = last ? `${last.charAt(0)}.` : "";
      const composed = [first, initial].filter(Boolean).join(" ").trim();
      return composed || this.lineProfile.displayName || "-";
    },
    memberSince() {
      if (!this.profile.created_time) return "-";
      return this.$moment(this.profile.created_time).format("DD MMM YYYY");
    },
    birthdayDisplay() {
      if (!this.profile.birthday) return "-";
      if (this.$moment(this.profile.birthday).format("YYYY") == "1753")
        return "-";
      return this.profile.have_year_birth === false
        ? this.$dateFormat(this.profile.birthday, "DD/MM")
        : this.$dateFormat(this.profile.birthday, "DD/MM/YYYY");
    },
    telephoneDisplay() {
      const val = this.profile.telephone;
      if (!val) return "-";
      return `${val.substring(0, 3)} - ${val.substring(3, 6)} - ${val.substring(
        6,
        10
      )}`;
    },
    memberLevelId() {
      return this.profile.member_level_id;
    },
    memberLogo() {
      return this.$store.state.domain + this.$store.state.theme.themeLogoLine;
    },
    memberLevel() {
      const source = this.$store.state.shortProfile || this.profile || {};
      if (!Array.isArray(source.member_list)) return {};
      return (
        source.member_list.find(item => item.id == source.member_level_id) ||
        source.member_list[0] ||
        {}
      );
    },
    tierBadge() {
      return this.memberLevel.icon || "";
    },
    birthdayIcon() {
      return BIRTHDAY_ICON;
    },
    phoneIcon() {
      return PHONE_ICON;
    },
    showLanguageSwitcher() {
      return this.languageList.length > 1;
    },
    currentLanguage() {
      return (
        this.languageList.find(lang => lang.id == this.langs.lang) ||
        this.languageList[0] ||
        {}
      );
    }
  },
  async created() {
    await this.getLanguageList();
  },
  watch: {
    "$route.path"() {
      if (this.$cookies.isKey("lang")) this.langs = this.$cookies.get("lang");
    }
  },
  methods: {
    async getLanguageList() {
      if (this.$store.state.languageList.length == 0) {
        this.languageList = await this.$store.dispatch("getLanguage");
        return;
      }
      this.languageList = this.$store.state.languageList;
    },
    async changeLang(val) {
      const index = this.languageList.findIndex(el => el.id == val);
      if (index < 0 || this.langs.lang == val) return;

      this.$refs.modalLoading.show();
      try {
        const selected = this.languageList[index];
        const payload = {
          lang: selected.id,
          name: selected.name,
          flag: selected.image_url
        };
        await this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, lang_id: String(selected.id) }
        });
        await this.$cookies.set("lang", JSON.stringify(payload));
        refreshFont();
        this.langs = payload;
        await this.$getLang();
        await this.$store.dispatch("getProvince", false);
        await this.$store.dispatch("refreshUserProfile");
      } finally {
        this.$refs.modalLoading.hide();
      }
    },
    goEditProfile() {
      this.$router.push("/manage/profile");
    },
    modalQR() {
      this.$refs.qrCode.show();
    },
    goPrivilege() {
      if (!this.memberLevelId) return;
      this.$router.push("/member/" + this.memberLevelId);
    },
    goSetting() {
      this.$router.push("/setting");
    },
    goBannerPreview() {
      this.$router.push("/banner-preview");
    },
    async logout() {
      const result = await this.dialog.showConfirm({
        text: this.$t("confirm_logout"),
        button: {
          true: { msg: this.$t("confirm"), class: ["btn-danger"] },
          false: { msg: this.$t("cancel"), class: ["btn-secondary"] }
        }
      });
      if (!result) return;
      try {
        this.$refs.modalLoading.show();
        const data = await this.$store.dispatch("unpairUser");
        if (data.result == 1) {
          await this.$router.replace("/validatetelephone");
        } else {
          window.alert("Internal Server Error.");
        }
      } catch (error) {
        console.error("lacoste logout", error);
      } finally {
        this.$refs.modalLoading.hide();
      }
    }
  }
};
</script>

<template>
  <div class="lacoste-home" data-test="lacoste-home">
    <header class="lacoste-home__header" data-test="lacoste-home-header">
      <img
        :src="memberLogo"
        @error="e => (e.target.src = handleImageSrc)"
        class="lacoste-home__logo"
        :alt="$t('profile')"
        data-test="lacoste-home-logo"
      />
      <div
        v-if="showLanguageSwitcher"
        class="lacoste-home__lang"
        data-test="lacoste-home-lang"
      >
        <v-menu location="bottom end">
          <template v-slot:activator="{ props }">
            <button
              data-lang="language"
              type="button"
              class="lacoste-home__lang-btn"
              v-bind="props"
              data-test="lacoste-home-lang-btn"
              :aria-label="$t('language')"
            >
              <font-awesome-icon :icon="['fas', 'globe']" />
              <span class="f-body f-bold">
                {{ currentLanguage.display_name }}
              </span>
            </button>
          </template>
          <v-list data-test="lacoste-home-lang-menu">
            <v-list-item
              v-for="lang in languageList"
              :key="'lacoste-lang-' + lang.id"
              :data-test="`lacoste-home-lang-item-${lang.id}`"
              @click="changeLang(lang.id)"
            >
              <div class="lacoste-home__lang-item">
                <span class="flag-lang">{{ lang.image_url }}</span>
                <span>{{ lang.display_name }}</span>
                <font-awesome-icon
                  v-if="lang.id == langs.lang"
                  icon="check"
                  class="ml-auto"
                />
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </header>

    <section class="lacoste-home__qr-card" data-test="lacoste-home-qr-card">
      <div
        class="lacoste-home__qr-media"
        @click="modalQR()"
        data-test="lacoste-home-qr-btn"
      >
        <qrcode-vue
          v-if="profile.member_id"
          :value="String(profile.member_id)"
          :size="90"
          level="M"
          data-test="lacoste-home-qr"
        />
        <img
          v-else
          :src="handleImageSrc"
          class="lacoste-home__qr-placeholder"
          alt="qr placeholder"
        />
        <span
          class="f-helper text-underline lacoste-home__qr-caption"
          data-test="lacoste-home-qr-caption"
        >
          {{ $t("scan_me") || "Scan me" }}
        </span>
      </div>

      <div class="lacoste-home__qr-info">
        <div
          class="f-body-sm lacoste-home__welcome"
          data-test="lacoste-home-welcome"
        >
          {{ $t("welcome") || "Welcome" }}
        </div>
        <div
          class="f-title f-bold lacoste-home__short-name"
          data-test="lacoste-home-short-name"
        >
          {{ shortName }}
        </div>
        <div
          class="f-body color-theme-secondary"
          data-test="lacoste-home-member-id"
        >
          {{ $t("member_id") || "Member ID" }} : {{ profile.member_id || "-" }}
        </div>
        <div
          class="f-body color-theme-secondary"
          data-test="lacoste-home-member-since"
        >
          {{ $t("member_since") || "Member Since" }} : {{ memberSince }}
        </div>
      </div>

      <div class="lacoste-home__menu" data-test="lacoste-home-menu">
        <v-menu location="bottom end">
          <template v-slot:activator="{ props }">
            <c-btn
              flat
              :ripple="false"
              type="icon"
              size="x-small"
              v-bind="props"
              data-test="lacoste-home-menu-toggle"
            >
              <font-awesome-icon
                :icon="['fas', 'ellipsis-v']"
                class="f-title color-primary"
              />
            </c-btn>
          </template>
          <v-list>
            <v-list-item
              data-lang="profile"
              v-if="displayEditProfile"
              @click="goEditProfile"
              data-test="lacoste-home-menu-profile"
            >
              {{ $t("profile") }}
            </v-list-item>
            <v-list-item
              data-lang="privilege"
              v-if="displayMemberLevel && memberLevelId"
              @click="goPrivilege"
              data-test="lacoste-home-menu-privilege"
            >
              {{ $t("member_benefit") }}
            </v-list-item>
            <v-list-item
              data-lang="news"
              v-if="displayMemberLevel && memberLevelId"
              @click="goBannerPreview"
              data-test="lacoste-home-menu-privilege"
            >
              {{ $t("news") }}
            </v-list-item>
            <v-list-item
              data-lang="setting"
              v-if="displaySettingBtn"
              @click="goSetting"
              data-test="lacoste-home-menu-setting"
            >
              {{ $t("setting") }}
            </v-list-item>
            <v-list-item
              data-lang="logout"
              v-if="displayLogoutButton && $store.state.isMemberBypass == 0"
              @click="logout"
              data-test="lacoste-home-menu-logout"
            >
              {{ $t("logout") }}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </section>

    <section
      class="lacoste-home__profile-card"
      data-test="lacoste-home-profile-card"
    >
      <div class="lacoste-home__profile-top">
        <img
          :src="tierBadge"
          @error="e => (e.target.src = handleImageSrc)"
          class="lacoste-home__tier-badge"
          alt="tier"
          data-test="lacoste-home-tier-badge"
        />
      </div>
      <div class="lacoste-home__avatar-wrap">
        <img
          :src="avatar"
          @error="e => (e.target.src = handleImageSrc)"
          class="lacoste-home__avatar"
          alt="avatar"
          data-test="lacoste-home-avatar"
        />
      </div>
      <div class="lacoste-home__profile-body">
        <div
          class="f-heading f-bold lacoste-home__full-name"
          data-test="lacoste-home-full-name"
        >
          {{ fullName }}
        </div>
        <div
          class="f-body color-theme-secondary"
          data-test="lacoste-home-email"
        >
          {{ profile.email || "-" }}
        </div>

        <div class="lacoste-home__tiles">
          <div
            class="lacoste-home__tile"
            data-test="lacoste-home-tile-birthday"
          >
            <img
              :src="birthdayIcon"
              @error="e => (e.target.src = handleImageSrc)"
              class="lacoste-home__tile-icon"
              alt="birthday"
            />
            <span class="f-body">{{ birthdayDisplay }}</span>
          </div>
          <div class="lacoste-home__tile" data-test="lacoste-home-tile-phone">
            <img
              :src="phoneIcon"
              @error="e => (e.target.src = handleImageSrc)"
              class="lacoste-home__tile-icon"
              alt="telephone"
            />
            <span class="f-body">{{ telephoneDisplay }}</span>
          </div>
        </div>
      </div>
    </section>

    <ModalLoading ref="modalLoading" />
    <ModalQrCode ref="qrCode" :value="String(profile.member_id || '')" />
  </div>
</template>

<style lang="scss" scoped>
.lacoste-home {
  --lacoste-radius-sm: 8px;
  --lacoste-radius-md: 12px;
  --lacoste-radius-lg: 20px;
  --lacoste-radius-xl: 24px;
  --lacoste-radius-pill: 999px;
  --lacoste-surface-on-primary: var(--font-primary-color, #ffffff);
  --lacoste-card-shadow: 0 6px 18px rgba(0, 0, 0, 0.267);

  display: flex;
  flex-direction: column;
  gap: 24px;
  // margin: -12px;
  padding: 16px;
  background: var(--primary-color);
  min-height: 100vh;
}

.lacoste-home__header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8px 0 16px;
  height: 100px;
}

.lacoste-home__logo {
  max-height: 96px;
  max-width: 160px;
  object-fit: contain;
}

.lacoste-home__lang {
  position: absolute;
  top: 0%;
  right: 4px;
  // transform: translateY(-50%);
}

.lacoste-home__lang-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 0;
  border-radius: var(--lacoste-radius-pill);
  background: transparent;
  color: var(--lacoste-surface-on-primary);
}

.lacoste-home__lang-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
}

.lacoste-home__qr-card {
  position: relative;
  display: flex;
  gap: 14px;
  padding: 22px;
  border-radius: var(--lacoste-radius-lg);
  background: #fff;
  box-shadow: var(--lacoste-card-shadow);
}

.lacoste-home__qr-media {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  cursor: pointer;
}

.lacoste-home__qr-placeholder {
  width: 90px;
  height: 90px;
  object-fit: contain;
  border-radius: var(--lacoste-radius-sm);
}

.lacoste-home__qr-caption {
  color: var(--primary-color);
}

.lacoste-home__qr-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lacoste-home__welcome {
  color: var(--primary-color);
}

.lacoste-home__short-name {
  color: var(--text-color, #111);
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lacoste-home__menu {
  position: absolute;
  // top: 6px;
  right: 6px;
  color: var(--text-color, #111);
}

.lacoste-home__profile-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 20px;
  border-radius: var(--lacoste-radius-lg);
  background: #fff;
  overflow: hidden;
  box-shadow: var(--lacoste-card-shadow);
}

.lacoste-home__profile-top {
  position: relative;
  width: 100%;
  height: 120px;
  background: var(--primary-color);
}

.lacoste-home__tier-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: var(--lacoste-radius-pill);
}

.lacoste-home__avatar-wrap {
  // margin-top: -60px;
  padding: 4px;
  border-radius: var(--lacoste-radius-pill);
  background: #fff;
  position: absolute;
  top: 60px;
}

.lacoste-home__avatar {
  display: block;
  width: 120px;
  height: 120px;
  border-radius: var(--lacoste-radius-pill);
  object-fit: cover;
}

.lacoste-home__profile-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 72px 16px 0;
  width: 100%;
  text-align: center;
}

.lacoste-home__full-name {
  color: var(--text-color, #111);
}

.lacoste-home__tiles {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 100%;
  margin-top: 14px;
}

.lacoste-home__tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 8px;
  border-radius: var(--lacoste-radius-md);
  background: var(--primary-color);
  color: var(--lacoste-surface-on-primary);
}

.lacoste-home__tile-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
</style>
